﻿// ------------------------------
// ローディング
// ------------------------------
$(function () {
  $('.c_xt-evo__loader-bg').delay(300).fadeOut(800);
});

// ------------------------------
// KV動画切り替え（768px以下: _sp / それ以上: _pc）
// ------------------------------
$(function () {
  var $video = $('.c_xt-evo__kv__video');
  if (!$video.length) return;

  var $kv = $video.closest('.c_xt-evo__kv');
  var el = $video.get(0);
  var pcSrc = $video.attr('data-pc-src');
  var spSrc = $video.attr('data-sp-src');
  if (!pcSrc || !spSrc) return;
  var mq = window.matchMedia('(max-width: 768px)');
  var currentSrc = '';

  function playVideo() {
    var playPromise = el.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function setKvVideo() {
    var nextSrc = mq.matches ? spSrc : pcSrc;

    if (currentSrc === nextSrc) return;

    currentSrc = nextSrc;
    $kv.removeClass('c_xt-evo__kv--playing');
    el.preload = 'auto';
    el.src = nextSrc;
  }

  $video.on('canplay loadeddata', function () {
    playVideo();
  });

  $video.on('playing', function () {
    $kv.addClass('c_xt-evo__kv--playing');
  });

  $video.on('emptied', function () {
    $kv.removeClass('c_xt-evo__kv--playing');
  });

  setKvVideo();

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', setKvVideo);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(setKvVideo);
  }
});

// ------------------------------
// 画像切り替え
// ------------------------------
$(function () {
  var $setElem = $('.c_xt-evo__switch'),
    pcName = '_pc',
    spName = '_sp',
    replaceWidth = 769;

  $setElem.each(function () {
    var $this = $(this);

    function imgSize() {
      var windowWidth = parseInt($(window).width());

      if (windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(spName, pcName));
      } else {
        $this.attr('src', $this.attr('src').replace(pcName, spName));
      }
    }

    $(window).resize(imgSize);
    imgSize();
  });
});

$(function () {
  var $setElem = $('.c_xt-evo__switch-collection'),
    pcName = '_pc',
    spName = '_sp',
    replaceWidth = 768;

  $setElem.each(function () {
    var $this = $(this);

    function imgSize() {
      var windowWidth = parseInt($(window).width());

      if (windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(spName, pcName));
      } else {
        $this.attr('src', $this.attr('src').replace(pcName, spName));
      }
    }

    $(window).resize(imgSize);
    imgSize();
  });
});

// ------------------------------
// 固定コレクションボタン
// ------------------------------
$(function () {
  var $btn = $('.c_xt-evo__btn-collection-fixed');
  var $collection = $('.c_xt-evo__collection');
  if (!$btn.length || !$collection.length) return;

  var showOffset = 100;

  function updateCollectionFixedBtn() {
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var collectionTop = $collection.offset().top;
    var collectionInView = scrollTop + windowHeight > collectionTop;

    if (scrollTop > showOffset && !collectionInView) {
      $btn.addClass('c_xt-evo__btn-collection-fixed--show');
    } else {
      $btn.removeClass('c_xt-evo__btn-collection-fixed--show');
    }
  }

  $(window).on('scroll resize', updateCollectionFixedBtn);
  updateCollectionFixedBtn();
});

// ------------------------------
// コレクションナビモーダル
// ------------------------------
$(function () {
  var $root = $('.c_xt-evo');
  var $modal = $root.find('.c_xt-evo__modal-collection');
  if (!$modal.length) return;

  function openModal(e) {
    e.preventDefault();
    $modal.stop(true, true).fadeIn(400);
  }

  function closeModal() {
    $modal.stop(true, true).fadeOut(400);
  }

  $root.find('.c_xt-evo__btn-collection-fixed').on('click', openModal);
  $root.find('.c_xt-evo__modal-collection__close').on('click', closeModal);
  $modal.on('click', function (e) {
    if ($(e.target).closest('.c_xt-evo__collection-nav__item, .c_xt-evo__modal-collection__close').length) {
      return;
    }
    closeModal();
  });
});

// ------------------------------
// スムーススクロール
// ------------------------------
$(function () {
  var headerHight = -1;

  $('.c_xt-evo a[href^="#"]').click(function (e) {
    if ($(this).closest('.c_xt-evo__btn-collection-fixed').length || $(this).closest('.c_xt-evo__modal-collection').length) {
      e.preventDefault();
      return;
    }

    var href = $(this).attr('href');
    var target = $(href === '#' || href === '' ? 'html' : href);
    var position = target.offset().top - headerHight;

    $('html, body').animate({ scrollTop: position }, 550, 'swing');
    return false;
  });
});

// ------------------------------
// ふわっと表示
// ------------------------------
function fuwat(selector, offset, className) {
  $(selector).css('visibility', 'hidden');

  $(window).scroll(function () {
    var windowHeight = $(window).height(),
      topWindow = $(window).scrollTop();

    $(selector).each(function () {
      var objectPosition = $(this).offset().top;

      if (topWindow > objectPosition - windowHeight + offset) {
        $(this).addClass(className);
      }
    });
  });
}

$(function () {
  fuwat('.c_xt-evo__fuwat', 200, 'c_xt-evo__fuwatAnime');
  fuwat('.c_xt-evo__fuwat02', 300, 'c_xt-evo__fuwatAnime02');
  fuwat('.c_xt-evo__fuwat03', 300, 'c_xt-evo__fuwatAnime03');
  fuwat('.c_xt-evo__fuwat04', 300, 'c_xt-evo__fuwatAnime04');
});
